import { trainerProfileService } from "../services/trainerProfileService";
import { useAsyncData } from "./useAsyncData";

export function useTrainerProfile(tenantId?: string | null) {
  return useAsyncData(
    () =>
      tenantId
        ? trainerProfileService.getCurrent(tenantId)
        : Promise.reject(new Error("No workspace selected.")),
    [tenantId],
  );
}
